import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SelfEntryRepository {
  constructor(private apiService: ApiService) {}

  public sent(entrySummaryId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/entry-summaries/sent`,
      null,
      {
        params: { id: entrySummaryId },
      },
      { isShowLoader },
    );
  }

  public calculate(entrySummaryId: number, isShowLoader: boolean = true): Observable<never> {
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/entry-summaries/calculated`,
      null,
      {
        params: { id: entrySummaryId },
      },
      { isShowLoader },
    );
  }
}
